export default "__VITE_ASSET__Bh97vRad__"